import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = { size?: Unit; color?: Color };
export const LineupEdit = ({ size = 2, color }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ height: unitMapping[size] }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.1464 9.85355L8.5 13.5V15.5H10.5L14.1464 11.8536L12.1464 9.85355Z"
      fill={color}
    />
    <path
      d="M12.8536 9.14645L14.8536 11.1464L15.5858 10.4142C15.851 10.149 16 9.78929 16 9.41421C16 8.63317 15.3668 8 14.5858 8C14.2107 8 13.851 8.149 13.5858 8.41421L12.8536 9.14645Z"
      fill={color}
    />
    <path
      d="M16.8013 3C17.4635 3.00062 18.0015 3.53784 18.0015 4.2002V19.7998C18.0014 20.4621 17.4635 20.9994 16.8013 21H7.35107C6.68837 21 6.15093 20.4625 6.15088 19.7998V4.2002C6.15088 3.53745 6.68833 3 7.35107 3H16.8013ZM4.80127 6.60059H3.60107V17.5508H4.80127V19.9502H2.40088C1.73828 19.9502 1.20092 19.4125 1.20068 18.75V5.40039C1.20068 4.73765 1.73814 4.2002 2.40088 4.2002H4.80127V6.60059ZM21.6011 4.2002C22.2634 4.2007 22.8013 4.73796 22.8013 5.40039V18.75C22.801 19.4122 22.2632 19.9497 21.6011 19.9502H19.2007V17.5508H20.4009V6.60059H19.2007V4.2002H21.6011ZM8.55127 11.3281L7.43994 12.4395L7.00049 13.5V15.5L8.50049 17H8.55127V18.6006H15.6011V12.207H15.9146L16.647 11.4746C17.1933 10.9281 17.5005 10.1868 17.5005 9.41406C17.5004 8.16195 16.7096 7.09589 15.6011 6.68359V5.40039H8.55127V11.3281ZM8.55127 15.5H8.50049V13.5L8.55127 13.4492V15.5ZM15.6011 8.43066C15.8477 8.68519 16.0004 9.0317 16.0005 9.41406C16.0005 9.78156 15.8563 10.1339 15.6011 10.3975V8.43066Z"
      fill={color}
    />
  </svg>
);
